// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"oq-z","imageAndVideoCount":"pq-z","imageAndVideoContainer":"qq-z","viewAllReviews":"rq-z"};